<!-- 充值 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>充值信息</span>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">公司名称</td>
            <td>{{userInfo.companyName}}</td>
            <td class="td-head">公司简称</td>
            <td>{{userInfo.shortName}}</td>
          </tr>
          <tr>
            <td class="td-head">充值金额（元）</td>
            <td>
              <el-input v-if="type=='add'" v-model="userInfo.rechargeAmount" placeholder="" clearable></el-input>
              <span v-if="type=='edit'">{{userInfo.rechargeAmount}}</span>
            </td>
            <td class="td-head">当前剩余金额（元）</td>
            <td>{{userInfo.residualAmount}}</td>
          </tr>
          <tr>
            <td class="td-head">充值类型</td>
            <td>
              <div v-if="type=='add'">
                <el-radio @change="czlxChangFun()" v-for="(item,index) in czlxOptions" v-model="userInfo.rechargeType" :key="index" :label="item.value">{{item.name}}</el-radio>
              </div>
              <span v-if="type=='edit'">{{userInfo.rechargeType}}</span>
            </td>
            <td class="td-head">使用期限</td>
            <td>
              <div class="qx-box" v-if="type!='edit'">
                <div v-if="type=='add' && !isXuFei">
                  <el-select v-model="userInfo.termOfUse" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in dictionary.term_type"
                      :key="index"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <span v-if="type=='edit'">{{$common.toStr(userInfo.termOfUse,dictionary.term_type)}}</span>
            </td>
          </tr>
          <tr v-if="conversionRatioShow && type=='add'">
            <td class="td-head">剩余金额折算比例</td>
            <td>
              <div class="qx-box" v-if="type!='edit'">
                <div>
                  <el-select v-model="userInfo.conversionRatio" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in dictionary.conversion_ratio"
                      :key="index"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </td>
            <td class="td-head"></td>
            <td></td>
          </tr>
          <tr v-if="type=='edit' && userInfo.conversionRatio">
            <td class="td-head">剩余金额折算比例</td>
            <td>
              <span>{{userInfo.conversionRatio*100}}%</span>
            </td>
            <td class="td-head"></td>
            <td></td>
          </tr>
          <tr>
            <td class="td-head">开始日期</td>
            <td>{{userInfo.startTime}}</td>
            <td class="td-head">结束日期</td>
            <td>{{userInfo.endTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box" v-if="ApiList.length>0">
      <div class="model-title">
        <span>接口单价设置</span>
      </div>
      <div class="model-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
            <el-table
              v-if="activeName==item.interId"
              ref="multipleTable"
              :data="item.items"
              border
              header-row-class-name="tableHead"
              style="width: 65.2%"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange">
              <el-table-column
                type="selection"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column
                prop="interDesc"
                label="接口名称"
                min-width="56%">
              </el-table-column>
              <el-table-column
                label="接口单价（元）"
                min-width="22%">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.interUnitPrice" placeholder="请输入接口单价"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="计费方式"
                min-width="22%">
                <template slot-scope="scope">
                  <el-radio v-model="scope.row.feeType" :label="1">查得</el-radio>
                  <el-radio v-model="scope.row.feeType" :label="2">查询</el-radio>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <a class="select-box-btn" v-if="ApiList.length>0 || type=='add'" @click="sureFun()">确定</a>
  </div>
</template>

<script>
export default {
  name: 'RechargePagePrepay',
  data () {
    return {
      type:this.$route.query.type || '',
      userInfo:{
        id:this.$route.query.id || '',
        companyName:'',
        shortName:'',
        rechargeType:'1',
        rechargeAmount:0,
        residualAmount:0,
        termOfUse:'1',
        startTime:'',
        endTime:'',
        conversionRatio:'1.0'
      },
      conversionRatioShow:false,
      isXuFei:false,
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      czlxOptions:[],
      activeName: '',
      ApiList:[],
      multipleSelectionAll: {},   // 所有选中的数据包含跨页数据
      multipleSelection: [],   // 当前页选中的数据
    }
  },
  mounted () {
    var _this=this;
    if(_this.type=='add'){
      _this.getAddUserInfoFun();
    }else if('edit'){
      _this.getEditUserInfoFun();
    };
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      // console.log(tab, event);
      _this.$nextTick(() => {
        var tabData=[];
        _this.ApiList.forEach(function(dataItem){
          if(dataItem.interId==_this.activeName){
            tabData=dataItem.items;
          };
        })
        if(_this.multipleSelectionAll[_this.activeName]){
          _this.multipleSelectionAll[_this.activeName].forEach(function(item){
            tabData.forEach(function(dataItem){
              if (item.interId == dataItem.interId) {
                _this.$refs.multipleTable[0].toggleRowSelection(dataItem, true)
              }
            })
          })
        }
      });
    },
    //获取充值用户信息(充值)
    getAddUserInfoFun(){
      var _this=this;
      _this.$axios.post('/requestApi/recharge/before?id='+_this.userInfo.id)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            // console.log("====="+JSON.stringify(data));
            _this.userInfo.companyName=data.data.comName;
            _this.userInfo.shortName=data.data.comBriefName;
            _this.userInfo.residualAmount=data.data.accountAmount;
            _this.ApiList=[];
            data.data.interList.forEach(function(item){
              var itemObj=new Object();
              itemObj.interId=item.interId;
              itemObj.interDesc=item.interDesc;
              itemObj.items=[];
              item.items.forEach(function(itemChild){
                itemObj.items.push(itemChild)
              });
              _this.ApiList.push(itemObj);
            });
            _this.ApiList.forEach(function(item){
              item.items.forEach(function(itemChild){
                if(itemChild.interUnitPrice==null){
                  itemChild.interUnitPrice=0;
                };
                if(itemChild.feeType==null){
                  itemChild.feeType=1;
                };
              });
            });
            if(_this.ApiList.length>0){
              _this.activeName=_this.ApiList[0].interId;
            };
            _this.czlxOptions=data.data.dictVoList;
            _this.userInfo.rechargeType=_this.czlxOptions[0].value;
            _this.czlxChangFun();
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //获取充值用户信息(修改)
    getEditUserInfoFun(){
      var _this=this;
      _this.$axios.post('/requestApi/recharge/show?id='+_this.userInfo.id)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.userInfo.companyName=data.data.comName;
            _this.userInfo.shortName=data.data.comBriefName;
            _this.userInfo.residualAmount=data.data.accountAmount;
            _this.userInfo.rechargeAmount=data.data.rechargeAmount;
            _this.userInfo.rechargeType=data.data.rechargeType;
            _this.userInfo.startTime=data.data.startDate;
            _this.userInfo.endTime=data.data.endDate;
            if(_this.userInfo.rechargeType=='3'){
              _this.isXuFei=true;
            };
            _this.userInfo.termOfUse=_this.toStr(data.data.useTerm,_this.dictionary.term_type);
            _this.userInfo.conversionRatio=data.data.conversionRatio;
            _this.ApiList=[];
            data.data.interList.forEach(function(item){
              var itemObj=new Object();
              itemObj.interId=item.interId;
              itemObj.interDesc=item.interDesc;
              itemObj.items=[];
              item.items.forEach(function(itemChild){
                itemObj.items.push(itemChild)
              });
              _this.ApiList.push(itemObj);
            });
            _this.ApiList.forEach(function(item){
              _this.multipleSelectionAll[item.interId]=[];
              item.items.forEach(function(itemChild){
                if(itemChild.interUnitPrice==null){
                  itemChild.interUnitPrice=0;
                };
                if(itemChild.isBinding==1){
                  _this.multipleSelectionAll[item.interId].push(itemChild);
                };
              });
            });
            _this.handleClick();
            if(_this.ApiList.length>0){
              _this.activeName=_this.ApiList[0].interId;
            };
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //点击确定
    sureFun:function(){
      var _this=this;
      if(_this.userInfo.rechargeAmount==''){
        _this.$message("请输入充值金额");
      }else{
        var loading = this.$loading({
          lock: true,
          text: '请求中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var selectenData=[];
        for(var value in _this.multipleSelectionAll){
          if(_this.multipleSelectionAll[value].length>0){
            _this.multipleSelectionAll[value].forEach(function(item){
              selectenData.push(item);
            });
          }
        };
        var sendData=new Object();
        sendData.rechargeRecord=new Object();
        sendData.rechargeRecord.userId=_this.userInfo.id;
        sendData.interfacePriceList=selectenData;
        var url='';
        if(_this.type=='add'){
          url='/requestApi/recharge';
          sendData.rechargeRecord.rechargeAmount=_this.userInfo.rechargeAmount;
          sendData.rechargeRecord.rechargeType=_this.userInfo.rechargeType;
          sendData.rechargeRecord.useTerm=_this.userInfo.termOfUse;
          
          sendData.rechargeRecord.conversionRatio=_this.userInfo.conversionRatio;
        }else if('edit'){
          url='/requestApi/recharge/update';
        };
        _this.$axios.post(url,sendData)      
          .then(function(response){
            loading.close();
            let data = response.data;
            if(data.meta.retCode==0){
              _this.$message({
                message: '保存成功',
                type: 'success'
              });
              _this.$router.push({path:'/qxfp'});
            }else{
              _this.$message({
                message: data.meta.friendlyMsg,
                type: 'warning'
              });
            }
          })
          .catch(function(error){
            loading.close();
            console.log(error)
          });
      }
    },
    //点击表格复选框
    handleSelectionChange: function(arr) {
      var _this=this;
      _this.multipleSelection = arr;
      _this.multipleSelectionAll[_this.activeName]=_this.multipleSelection;
    },
    toStr:function(str,arr){
      var idNum='';
      arr.forEach(function(item) {
        if(item.name==str){
          idNum=item.value;
        }
      });
      return idNum
    },
    czlxChangFun:function(){
      var _this=this;
      if(_this.userInfo.rechargeType=='3'){
        _this.isXuFei=true;
      }else{
        _this.isXuFei=false;
      };
      if(_this.userInfo.rechargeType=='2'){
        _this.conversionRatioShow=true;
      }else{
        _this.conversionRatioShow=false;
      };
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto;}
.qx-box{height: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/RechargePagePrepay.vue